var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,{"onClick":_vm.onClick,"isResolved":_vm.isResolved,"disabled":_vm.submit})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }